export const errors: { [key: string]: string } = {
  'User with given email does not exist.': 'E-mail não encontrado.',
  'usuário com este endereço de e-mail já existe.':
    'O e-mail informado já está em uso.',
  'Enter a valid phone number.': 'Informe um número de telefone válido.',
}
